import { Component } from 'preact';
import { connect } from 'unistore/preact';
import PRN from './prn/index';
import Refresh from './refresh';
import QrController from '../../controllers/qr';
import ScaleQR from './scale';
import { EVENT, log } from '../../common/logger';
import { locale } from '../../utils/i18n';
import { isNull } from '../../../../common/src/utils/common';
import { staticPath, isFunction, getKey } from '../../utils/common';
import { onChange } from '../../common/actions';
import CONSTANT, { CACHE } from '../../utils/constants';
import ProcessLoader from '../ProcessLoader';
import ToolTip from '../tooltip';

class QRCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      socketResponse: {}, // kafka payload
      sessionTimeOut: null, // timeout after which abandon transaction call
      wsConnect: false, // websocket connection created or not
      qrCode: '', // qr code
      showPRN: false, // show prn screen,
      reload: false, // show reload qr if connection not established
      socket: null, // websocket connection object
      zoom: false, // is qr code in zoom
      hideQR: false,
      showProcessing: false
    };

    if (props.qr) {
      this.state.qrCode = `data:image/png;base64,${props.qr.dataUrl}`;
    }

    this.logo = {
      paytm: `${staticPath()}/assets/images/logo-paytm.svg`,
      upi: `${staticPath()}/assets/images/logo-upi.svg`
    };
  }

  socketConnectListener = () => {
    this.setState({ wsConnect: true });
    log({ eventType: EVENT.WS_CREATE });
  };

  socketDisconnectListener = () => {
    log({ eventType: EVENT.WS_DISCONNECT });
    this.setState({ wsConnect: false });
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
    clearTimeout(this.state.sessionTimeOut);
  };

  roomListener = option => {
    if (option) {
      if (this.state.showProcessing !== option.showProcessing) {
        this.props.cache.getData(CACHE.STORE).setState({
          overlayValue: option.showProcessing ? CONSTANT.PROCESSING : ''
        });
      }

      this.setState({
        socketResponse: option.response,
        showPRN: option.showPRN,
        hideQR: option.hideQR,
        showProcessing: option.showProcessing
      });

      if (option.isPending) {
        this.props.onNotificationTextChange(locale('qr.scan.pending'));
      }

      if (Object.prototype.hasOwnProperty.call(option, 'timeout')) {
        clearTimeout(this.state.sessionTimeOut);
      }
    }
  };

  reloadQR = qr => {
    this.initWebSocket(qr);
    this.setReload(false);
  };

  setReload = reload => {
    this.setState({ reload });
  };

  initWebSocket = qr => {
    const socket = QrController.initSocket(
      qr,
      {
        connect: this.socketConnectListener,
        disconnect: this.socketDisconnectListener,
        roomListener: this.roomListener,
        reload: this.setReload
      },
      this.props.cache,
      this.props.instanceKey
    );

    this.setState({
      socket,
      hideQR: !socket,
      sessionTimeOut: QrController.attachEvents(qr, this.props.cache)
    });
  };

  componentDidMount() {
    this.initWebSocket(this.props.qr);
  }

  componentWillUnmount() {
    isFunction(getKey(this.state, 'socket.close')) &&
      this.state.socket.close(1000, this.props.instanceKey);
  }

  enlarge = (event, isZoom) => {
    this.setState({
      zoom: isNull(isZoom) ? !this.state.zoom : isZoom
    });
  };

  render({ qr }, { showPRN, qrCode, wsConnect, socketResponse, reload, zoom, hideQR }) {
    return (
      <div>
        <div className={`ptm-qr-wrap ptm-body-color`}>
          <div className={`ptm-left`}>
            <p className={`ptm-select-txt ptm-uppercase ptm-qr-pay-text`}>{locale('qr.pay')}</p>
            <div className={`ptm-qr-type ptm-pos-r ptm-body-color`}>
              {qr.upiQR ? locale('qr.scan.qrcode.upi') : locale('qr.scan.qrcode')}
              <ToolTip
                title={qr.upiQR ? locale('qr.scan.upi') : locale('qr.scan.paytm')}
                desc={qr.upiQR ? locale('qr.all.apps') : ''}
              />
            </div>
            <div className={`ptm-qr-logo`}>
              <img src={this.logo.paytm} data-key="qr-paytm" />
              {qr.upiQR ? <span className={`ptm-qr-pipe`}> | </span> : ''}
              {qr.upiQR && <img src={this.logo.upi} data-key="qr-upi" />}
            </div>
          </div>
          {!hideQR && (
            <div className={`ptm-right ptm-qr-right`}>
              {!wsConnect && reload && <Refresh reloadQR={() => this.reloadQR(qr)} />}
              {!wsConnect && !reload && (
                <div className={`ptm-qr-overlay ptm-border-color`}>
                  <ProcessLoader />
                </div>
              )}
              {wsConnect && (
                <div className={`ptm-qr-img-container`}>
                  <div className="ptm-qr-zoom-wrap ptm-border-color">
                    <img src={qrCode} alt="" data-key="qr-code" />
                    <div className={`ptm-qr-desc`}>
                      <p
                        className={`ptm-qr-zoom paytm-txt-center ptm-body-color`}
                        onClick={e => this.enlarge(e)}
                        data-key="qr-zoom"
                      >
                        {locale('qr.click.enlarge')}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {zoom && <ScaleQR qrCode={qrCode} upiQR={qr.upiQR} notify={this.enlarge} />}
          {showPRN && <PRN {...{ socketResponse, qr }} />}
        </div>
        <div class="ptm-global-bottom-border ptm-qr-bottom-border" />
      </div>
    );
  }
}

export default connect(
  'cache, instanceKey',
  onChange
)(QRCode);



// WEBPACK FOOTER //
// ./components/qr/index.js